// FIFA World Cup 2026 - Tournament Data
// Groups A-L, 4 teams per group, 48 teams total
// Tournament starts: June 11, 2026  |  Final: July 19, 2026

export const GROUPS = ['A','B','C','D','E','F','G','H','I','J','K','L'];

// Group stage display order (same as seed.js; IDs will be assigned by DB)
export const TEAMS_BY_GROUP = {
  A: ['Mexico','South Korea','South Africa','Czech Republic'],
  B: ['Canada','Switzerland','Qatar','Bosnia-Herzegovina'],
  C: ['Brazil','Morocco','Scotland','Haiti'],
  D: ['United States','Paraguay','Australia','Türkiye'],
  E: ['Germany','Ivory Coast','Ecuador','Curaçao'],
  F: ['Netherlands','Sweden','Tunisia','Intercontinental Playoff'],
  G: ['Belgium','Egypt','Iran','New Zealand'],
  H: ['Spain','Cape Verde','Saudi Arabia','Uruguay'],
  I: ['France','Senegal','Iraq','Norway'],
  J: ['Argentina','Algeria','Austria','Jordan'],
  K: ['Portugal','DR Congo','Uzbekistan','Colombia'],
  L: ['England','Croatia','Ghana','Panama'],
};

// Round of 32 bracket structure
// slot1/slot2 describe the team source; label is shown to the user
// bracketHalf: 'left' leads to SF1, 'right' leads to SF2
export const R32_MATCHES = [
  // ── Left half (top→bottom): Germany/Paraguay, France/Sweden, SA/Canada, Netherlands/Morocco, Portugal/Croatia, Spain/Austria, USA/Bosnia, Belgium/Senegal ──
  { id:'r32_m02', label:'Match 2',  slot1:'1E', slot1Label:'Winner E',       slot2:'3D', slot2Label:'3rd Place D',     bracketHalf:'left',  nextMatch:'r16_m01', nextSlot:'top' },
  { id:'r32_m05', label:'Match 5',  slot1:'1I', slot1Label:'Winner I',       slot2:'3F', slot2Label:'3rd Place F',     bracketHalf:'left',  nextMatch:'r16_m01', nextSlot:'bot' },
  { id:'r32_m01', label:'Match 1',  slot1:'2A', slot1Label:'Runner-up A',    slot2:'2B', slot2Label:'Runner-up B',     bracketHalf:'left',  nextMatch:'r16_m02', nextSlot:'top' },
  { id:'r32_m03', label:'Match 3',  slot1:'1F', slot1Label:'Winner F',       slot2:'2C', slot2Label:'Runner-up C',     bracketHalf:'left',  nextMatch:'r16_m02', nextSlot:'bot' },
  { id:'r32_m11', label:'Match 11', slot1:'2K', slot1Label:'Runner-up K',    slot2:'2L', slot2Label:'Runner-up L',     bracketHalf:'left',  nextMatch:'r16_m03', nextSlot:'top' },
  { id:'r32_m12', label:'Match 12', slot1:'1H', slot1Label:'Winner H',       slot2:'2J', slot2Label:'Runner-up J',     bracketHalf:'left',  nextMatch:'r16_m03', nextSlot:'bot' },
  { id:'r32_m09', label:'Match 9',  slot1:'1D', slot1Label:'Winner D',       slot2:'3B', slot2Label:'3rd Place B',     bracketHalf:'left',  nextMatch:'r16_m04', nextSlot:'top' },
  { id:'r32_m10', label:'Match 10', slot1:'1G', slot1Label:'Winner G',       slot2:'3I', slot2Label:'3rd Place I',     bracketHalf:'left',  nextMatch:'r16_m04', nextSlot:'bot' },
  // ── Right half (top→bottom): Brazil/Japan, IvoryCoast/Norway, Mexico/Ecuador, England/DRCongo, Argentina/CapeVerde, Australia/Egypt, Switzerland/Algeria, Colombia/Ghana ──
  { id:'r32_m04', label:'Match 4',  slot1:'1C', slot1Label:'Winner C',       slot2:'2F', slot2Label:'Runner-up F',     bracketHalf:'right', nextMatch:'r16_m05', nextSlot:'top' },
  { id:'r32_m06', label:'Match 6',  slot1:'2E', slot1Label:'Runner-up E',    slot2:'2I', slot2Label:'Runner-up I',     bracketHalf:'right', nextMatch:'r16_m05', nextSlot:'bot' },
  { id:'r32_m07', label:'Match 7',  slot1:'1A', slot1Label:'Winner A',       slot2:'3E', slot2Label:'3rd Place E',     bracketHalf:'right', nextMatch:'r16_m06', nextSlot:'top' },
  { id:'r32_m08', label:'Match 8',  slot1:'1L', slot1Label:'Winner L',       slot2:'3K', slot2Label:'3rd Place K',     bracketHalf:'right', nextMatch:'r16_m06', nextSlot:'bot' },
  { id:'r32_m14', label:'Match 14', slot1:'1J', slot1Label:'Winner J',       slot2:'2H', slot2Label:'Runner-up H',     bracketHalf:'right', nextMatch:'r16_m07', nextSlot:'top' },
  { id:'r32_m16', label:'Match 16', slot1:'2D', slot1Label:'Runner-up D',    slot2:'2G', slot2Label:'Runner-up G',     bracketHalf:'right', nextMatch:'r16_m07', nextSlot:'bot' },
  { id:'r32_m13', label:'Match 13', slot1:'1B', slot1Label:'Winner B',       slot2:'3J', slot2Label:'3rd Place J',     bracketHalf:'right', nextMatch:'r16_m08', nextSlot:'top' },
  { id:'r32_m15', label:'Match 15', slot1:'1K', slot1Label:'Winner K',       slot2:'3L', slot2Label:'3rd Place L',     bracketHalf:'right', nextMatch:'r16_m08', nextSlot:'bot' },
];

export const R16_MATCHES = [
  { id:'r16_m01', label:'R16 Match 1', bracketHalf:'left',  nextMatch:'qf_m01', nextSlot:'top' },
  { id:'r16_m02', label:'R16 Match 2', bracketHalf:'left',  nextMatch:'qf_m01', nextSlot:'bot' },
  { id:'r16_m03', label:'R16 Match 3', bracketHalf:'left',  nextMatch:'qf_m02', nextSlot:'top' },
  { id:'r16_m04', label:'R16 Match 4', bracketHalf:'left',  nextMatch:'qf_m02', nextSlot:'bot' },
  { id:'r16_m05', label:'R16 Match 5', bracketHalf:'right', nextMatch:'qf_m03', nextSlot:'top' },
  { id:'r16_m06', label:'R16 Match 6', bracketHalf:'right', nextMatch:'qf_m03', nextSlot:'bot' },
  { id:'r16_m07', label:'R16 Match 7', bracketHalf:'right', nextMatch:'qf_m04', nextSlot:'top' },
  { id:'r16_m08', label:'R16 Match 8', bracketHalf:'right', nextMatch:'qf_m04', nextSlot:'bot' },
];

export const QF_MATCHES = [
  { id:'qf_m01', label:'QF Match 1', bracketHalf:'left',  nextMatch:'sf_m01', nextSlot:'top' },
  { id:'qf_m02', label:'QF Match 2', bracketHalf:'left',  nextMatch:'sf_m01', nextSlot:'bot' },
  { id:'qf_m03', label:'QF Match 3', bracketHalf:'right', nextMatch:'sf_m02', nextSlot:'top' },
  { id:'qf_m04', label:'QF Match 4', bracketHalf:'right', nextMatch:'sf_m02', nextSlot:'bot' },
];

export const SF_MATCHES = [
  { id:'sf_m01', label:'Semi-Final 1', nextMatch:'final', nextSlot:'top' },
  { id:'sf_m02', label:'Semi-Final 2', nextMatch:'final', nextSlot:'bot' },
];

export const SCORING = {
  group_pos1: 3,
  group_pos2: 2,
  group_pos3: 1,
  third_advance: 2,
  r32: 3,
  r16: 5,
  qf: 8,
  sf: 11,
  '3rd': 5,
  final: 15,
};

export const TOURNAMENT_START = new Date('2026-06-11T18:00:00Z');
